import { render, staticRenderFns } from "./articulos.vue?vue&type=template&id=c6b162bc&"
import script from "./articulos.vue?vue&type=script&lang=js&"
export * from "./articulos.vue?vue&type=script&lang=js&"
import style0 from "./articulos.vue?vue&type=style&index=0&id=c6b162bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports